module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.withCreate && _vm.createInvoice && _vm.appointment && _vm.appointment.client) ? _c('v-navigation-drawer', {
    staticStyle: {
      "z-index": "15"
    },
    attrs: {
      "right": "",
      "overlay": "",
      "fixed": "",
      "bottom": "",
      "disable-resize-watcher": "",
      "disable-route-watcher": "",
      "stateless": "",
      "touchless": "",
      "hide-overlay": false,
      "width": "440"
    },
    model: {
      value: (_vm.createInvoice),
      callback: function($$v) {
        _vm.createInvoice = $$v
      },
      expression: "createInvoice"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline py-1 grey lighten-4"
  }, [_vm._v("\n        Create an invoice\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.createInvoice = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.computedRelationship && _vm.computedRelationship.id) ? _c('confirm-invoice', {
    attrs: {
      "with-header": false,
      "relationship": _vm.computedRelationship,
      "appointments": [_vm.appointment]
    },
    on: {
      "success": _vm.loadAppointment,
      "done": function($event) {
        return _vm.$emit("close")
      }
    },
    model: {
      value: (_vm.invoice),
      callback: function($$v) {
        _vm.invoice = $$v
      },
      expression: "invoice"
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.appointment && _vm.withDone) ? _c('v-list', {
    staticStyle: {
      "position": "fixed",
      "top": "0px",
      "left": "0px",
      "right": "0px",
      "z-index": "14"
    },
    attrs: {
      "dense": "",
      "flat": "",
      "dark": "",
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "loading": _vm.appointmentRequest.loading
    },
    on: {
      "click": _vm.loadAppointment
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1)], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [(_vm.formattedStatus && _vm.formattedStatus.theme) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    class: _vm.formattedStatus.theme,
    attrs: {
      "label": "",
      "dark": ""
    }
  }, [_vm._v("\n              " + _vm._s(_vm.formattedStatus.title) + "\n            ")]) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.appointmentInvoiceTitle) + "\n          ")], 1), _vm._v(" "), (_vm.appointment.invoice_description) ? _c('v-list-tile-sub-title', {
    domProps: {
      "textContent": _vm._s(_vm.appointment.invoice_description)
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.appointmentRequest.loading) ? _c('v-list-tile-action', [_c('v-progress-circular', {
    staticClass: "mr-3",
    attrs: {
      "indeterminate": "",
      "color": "amber",
      "width": "2"
    }
  })], 1) : _c('v-list-tile-action', [(_vm.withCreate) ? _c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "small": "",
      "icon": _vm.$vuetify.breakpoint.xs,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.createInvoice = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")]), _vm._v(" "), _c('span', {
    staticClass: "ml-2 hidden-xs-only"
  }, [_vm._v("Invoice")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-5"
  }, [_c('request-status', {
    attrs: {
      "request": _vm.requests.set_discount,
      "message200": "Discount successfully applied"
    }
  }), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.appointmentEditRequest,
      "message200": "Appointment details updated"
    }
  }), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.appointmentRequest,
      "message200": false
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "order-xs2": "",
      "order-sm1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Ready for invoicing",
      "persistent-hint": "",
      "hint": "Tick this so that you know this appointment can be safely added to invoices",
      "color": "success",
      "loading": _vm.appointmentEditRequest.loading
    },
    on: {
      "change": _vm.markAsInvoiceable
    },
    model: {
      value: (_vm.appointment.invoiceable),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "invoiceable", $$v)
      },
      expression: "appointment.invoiceable"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "order-xs1": "",
      "order-sm2": ""
    }
  }, [_c('v-text-field', {
    staticClass: "elevation-4 mt-2",
    attrs: {
      "box": "",
      "persistent-hint": "",
      "id": "appointmentPrice",
      "name": "appointmentPrice",
      "append-icon": "save",
      "loading": _vm.appointmentEditRequest.loading,
      "prefix": _vm.appointment.currency,
      "disabled": _vm.appointmentEditRequest.loading || (_vm.appointment.codes && _vm.appointment.codes.length > 0),
      "hint": _vm.appointmentPriceHint,
      "rules": _vm.appointmentPriceRules,
      "type": "tel",
      "label": "Appointment price"
    },
    on: {
      "blur": _vm.saveAppointmentDetails,
      "append:click": _vm.saveAppointmentDetails,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveAppointmentDetails.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.appointment.price),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "price", $$v)
      },
      expression: "appointment.price"
    }
  }), _vm._v(" "), (_vm.appointment) ? _c('v-text-field', {
    staticClass: "mt-2 mx-2",
    attrs: {
      "dense": "",
      "filled": "",
      "clearable": "",
      "loading": _vm.requests.set_discount.loading,
      "disabled": _vm.requests.set_discount.loading,
      "label": "Add a discount",
      "placeholder": "0.00",
      "prefix": _vm.appointment.currency,
      "append-icon": "save"
    },
    on: {
      "click:clear": function($event) {
        _vm.appointment.discount_amount = 0
      },
      "append:click": _vm.setDiscount,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.setDiscount.apply(null, arguments)
      },
      "blur": _vm.setDiscount
    },
    model: {
      value: (_vm.appointment.discount_amount),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "discount_amount", $$v)
      },
      expression: "appointment.discount_amount"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-expansion-panel', {
    staticClass: "elevation-4",
    attrs: {
      "flat": ""
    },
    model: {
      value: (_vm.activePanel),
      callback: function($$v) {
        _vm.activePanel = $$v
      },
      expression: "activePanel"
    }
  }, [_c('v-expansion-panel-content', [_c('div', {
    staticClass: "subheading",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Appointment information")]), _vm._v(" "), _c('v-form', {
    staticClass: "grey lighten-4"
  }, [_c('v-card', {
    staticClass: "grey lighten-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "name": "appointment-invoice-title",
      "append-icon": "save",
      "label": "Invoice title",
      "persistent-hint": "",
      "hint": "Change the title as it appears in the invoice"
    },
    on: {
      "blur": _vm.saveAppointmentDetails,
      "append:click": _vm.saveAppointmentDetails,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveAppointmentDetails.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.invoiceTitle),
      callback: function($$v) {
        _vm.invoiceTitle = $$v
      },
      expression: "invoiceTitle"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "appointmentDescription",
      "name": "appointmentDescription",
      "append-icon": "save",
      "label": "Appointment description",
      "persistent-hint": "",
      "hint": "You can add further information about the appointment here. For example: \"knee rehab\""
    },
    on: {
      "blur": _vm.saveAppointmentDetails,
      "append:click": _vm.saveAppointmentDetails,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveAppointmentDetails.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.invoiceDescription),
      callback: function($$v) {
        _vm.invoiceDescription = $$v
      },
      expression: "invoiceDescription"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('div', {
    staticClass: "subheading",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Medical aid coding")]), _vm._v(" "), _c('v-form', {
    staticClass: "grey lighten-4"
  }, [(_vm.activePanel === _vm.PANELS.CODES) ? _c('appointment-codes', {
    ref: "invoiceCodes",
    staticClass: "mt-4",
    attrs: {
      "with-clone": "",
      "editable": "",
      "with-refresh": "",
      "with-title": "",
      "appointment-id": _vm.appointment.id
    },
    on: {
      "pricechange": _vm.setAppointmentPrice
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('div', {
    staticClass: "subheading",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Product sales\n        ")]), _vm._v(" "), _c('v-form', [(_vm.activePanel === _vm.PANELS.PRODUCTS && _vm.appointment.id) ? _c('appointment-product', {
    attrs: {
      "appointment-id": _vm.appointment.id
    },
    on: {
      "updated": _vm.loadAppointment
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('div', {
    staticClass: "subheading",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('titles.invoices')) + "\n      ")]), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.invoiceRequest,
      "message200": false
    }
  }), _vm._v(" "), _c('v-form', {
    staticClass: "grey lighten-4"
  }, [_c('h3', {
    staticClass: "overline pa-4"
  }, [_vm._v("\n          This appointment is included in the following invoices\n        ")]), _vm._v(" "), (_vm.invoices && _vm.invoices.length > 0) ? _c('invoice-list', {
    staticClass: "pa-4",
    attrs: {
      "transition": "fade",
      "invoices": _vm.invoices
    },
    on: {
      "selected": _vm.gotoInvoice
    }
  }) : _c('div', {
    staticClass: "px-4 pb-4"
  }, [_vm._v("\n          No invoices found for this appointment\n        ")])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('div', {
    staticClass: "subheading",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Payments\n        ")]), _vm._v(" "), _c('v-form', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.appointment && _vm.appointment.payments) ? _c('payment-list', {
    attrs: {
      "with-delete": "",
      "appointment": _vm.appointment,
      "payments": _vm.appointment.payments
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "disabled": _vm.isPaid
    },
    on: {
      "click": function($event) {
        _vm.addPaymentDialog = true;
        _vm.touchPayment++
      }
    }
  }, [_vm._v("Add a payment")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xs
    },
    model: {
      value: (_vm.addPaymentDialog),
      callback: function($$v) {
        _vm.addPaymentDialog = $$v
      },
      expression: "addPaymentDialog"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Add a payment")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.addPaymentDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.activePanel === _vm.PANELS.PAYMENTS) ? _c('create-transaction', {
    attrs: {
      "with-appointment-info": false,
      "with-done": false,
      "touch": _vm.touchPayment,
      "appointment": _vm.appointment
    },
    on: {
      "success": function($event) {
        return _vm.loadAppointment()
      },
      "close": function($event) {
        _vm.addPaymentDialog = false
      }
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.appointment && _vm.appointment.financials) ? _c('appointment-price-details', {
    attrs: {
      "with-title": false
    },
    on: {
      "finalprice": function($event) {
        return _vm.$emit("finalprice")
      }
    },
    model: {
      value: (_vm.appointment.financials),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "financials", $$v)
      },
      expression: "appointment.financials"
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.createInvoice) ? _c('v-card-actions', {
    class: _vm.mobileCardActionsClasses,
    style: (_vm.mobileCardActionsStyles)
  }, [(_vm.withDone) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.withCreate) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.createInvoice = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")]), _vm._v(" Create invoice\n    ")], 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a0abb4a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/edit/InvoiceDetails.vue
// module id = 1492
// module chunks = 9